<span class="label" style="cursor: pointer" title="{{ tooltip }}" (click)="copy()">{{ name }}</span>